const list = {
  // =================================================================================================================
  components() {
    return [
      {
        'component': 'search-start-end',
        label: '작성일',
        value: 'date',
        query: {'ss': 'startDate', 'ee': 'endDate'},
        options: {
          default: {sd: '', ed: ''},
        }
      },
      {
        'component': 'search-column-keyword',
        label: '검색조건',
        value: 'column',
        query: {'ck_t': 'head', 'ck_k': 'keyword'},
        options: {hiddenList: ['Head 3', '작성년도']}
      },
      {
        'component': 'search-year', label: '연도', value: 'year', query: {'y': 'year'},
        options: {
          default: new Date().getFullYear()
        }
      },
    ]
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 검색연도
    let dateTarget = "created_at";
    let dateBegin = `${new Date().getFullYear()}-01-01`;
    let dateEnd = `${new Date().getFullYear()}-12-31`;
    if (search.year) {
      dateBegin = `${search.year}-01-01`;
      dateEnd = `${search.year}-12-31`;
    }
    //  검색일
    if (search.date) {
      if (search.date.startDate) dateBegin = search.date.startDate;
      if (search.date.endDate) dateEnd = search.date.endDate;
    }
    conditions.push({key: dateTarget, operator: '>=', value: dateBegin})
    conditions.push({key: dateTarget, operator: '<', value: new Date(dateEnd).addDays(1).format("yyyy-MM-dd")})


    //  검색조건
    const heads = list.getHead().map(e => {return {[e.name] : e.key}});
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({key: types[search.column.head], operator: 'LIKE', value: `%${search.column.keyword}%`})
    }
    return conditions;
  },


  // =================================================================================================================
  getHead: () => {
    return [
      {name: '작성년도', key: 'body.stdInfo.date'},
      {name: '부서', key: 'body.stdInfo.field_name'},
      {name: '소속명', key: 'body.stdInfo.department'},
      {name: '부서명', key: 'body.stdInfo.section'},
      {name: '작성자', key: 'body.stdInfo.writer_name'},
      {name: '작성일', key: ''},
    ]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0:
          return func.getContent(value).stdInfo.date? func.getContent(value).stdInfo.date.split('-')[0] : '' // 작성년도
        case 1:
          return func.getContent(value).stdInfo.field_name
        case 2:
          return func.getContent(value).stdInfo.department
        case 3:
          return func.getContent(value).stdInfo.section
        case 4:
          return func.getContent(value).stdInfo.writer_name
        case 5:
          return func.getCreatedDate(value)
      }
    } catch (e) { /*ignore*/
    }
    return ''
  },

  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
  getExcelList (excelList) {
    const list = []
    for (const post of excelList) {
      const body = JSON.parse(post.post_content).body
      const 위험물질들 = {};

      for (let i=0; i<body.물질안전보건자료.length; i++) {
        const 위험물질 = body.물질안전보건자료[i];
        위험물질들[위험물질.제품명] = 위험물질.구성성분.length;
      }

      list.push({
        '부서': body.stdInfo.field_name,
        '소속명': body.stdInfo.department,
        '부서명': body.stdInfo.section,
        '작성자': body.stdInfo.writer_name,
        '작성일': new Date(post.created_at).format("yyyy-MM-dd"),
        '전체 등록 물질 수': body.물질안전보건자료.length,
        '제품명/물질명': '',
        '구성성분 수': '',
      })
      const keys = Object.keys(위험물질들);
      if (keys.length > 0) {
        list[list.length-1]['제품명/물질명'] = keys[0];
        list[list.length-1]['구성성분 수'] = 위험물질들[keys[0]];
      }
      for (let i=1; i<keys.length; i++) {
        list.push({
          '부서': '',
          '소속명': '',
          '부서명': '',
          '작성자': '',
          '작성일': '',
          '전체 등록 물질 수': '',
          '제품명/물질명': keys[i],
          '구성성분 수': 위험물질들[keys[i]],
        })
      }
    }

    return list;
  }
}

export default list;
